import { SWRConfig } from 'swr';
import { useToast } from '@/shared/providers/toast-provider';
import type { SWRConfiguration } from 'swr';
import { useMemo, type ReactNode } from 'react';

interface SwrProviderProps {
  children: ReactNode;
  fallback?: SWRConfiguration['fallback'];
}

export const SwrProvider = ({ children, fallback }: SwrProviderProps) => {
  const { showErrorToast } = useToast();

  const swrConfig = useMemo<SWRConfiguration>(
    () => ({
      fallback,
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      onError: (error) => {
        if (
          error.status &&
          error.status !== 401 &&
          error.error !== 'error_registering_user'
        ) {
          showErrorToast(error);
        }
      },
    }),
    [fallback, showErrorToast]
  );

  return <SWRConfig value={swrConfig}>{children}</SWRConfig>;
};
